<template>
    
<div class="photos" v-if="is.active">

	<app-share type="photo" :identity="currentIdentity" class="photos-share" />
    <div class="photos-close" v-on:click="onCloseClick"><app-icon name="remove" /></div>
    <div class="photos-next is-left" v-on:click="onLeftClick"><app-icon name="caret-left" /></div>
    <div class="photos-next is-right" v-on:click="onRightClick"><app-icon name="caret-right" /></div>

    <div class="photos-current">

        <img class="photos-current-image" :class="{'is-loaded': is.loaded}" :src="currentImage" v-on:load="onImageLoaded" />

        <div class="photos-current-text" v-if="currentText">{{ currentText }}</div>

    </div>
    
    <div class="photos-reel">

        <div v-on:click.stop="onPhotoClick(photo.index)" v-for="(photo, index) in reel" class="photos-reel-item" :class="{'is-active': photo.index === current}" :key="index" :style="{backgroundImage: $util.thumbnail(photo.image)}"></div>

    </div>

</div>

</template>

<script>

export default {

    data: function() {

        return {

            is: {
                active: false,
                loaded: false
            },

            photos: [],
            current: 0

        }

    },

    computed: {

        currentImage: function() {

            return this.photos[this.current].image

		},
		
		currentIdentity: function() {

			return this.photos[this.current].identity

		},

        currentText: function() {

            return this.photos[this.current].name

        },

        reel: function() {

			var reel = []
			
			if (this.photos.length < 5) {

				for(var i=0; i<this.photos.length; i++) {

					reel.push({
						index: i,
						image: this.photos[i].image
					})
					
				}

			} else {

				if (this.photos.length > 3) {

					if (this.current <= 1) reel.push({
						index: this.photos.length - 2,
						image: this.photos[this.photos.length - 2].image
					})

					if (this.current > 1) reel.push({
						index: this.current - 2,
						image: this.photos[this.current - 2].image
					})

				}

				if (this.photos.length > 1) {

					if (this.current === 0) reel.push({
						index: this.photos.length - 1,
						image: this.photos[this.photos.length - 1].image
					})

					if (this.current > 0) reel.push({
						index: this.current - 1,
						image: this.photos[this.current - 1].image
					})

				}
					
				reel.push({
					index: this.current,
					image: this.photos[this.current].image
				})

				if (this.photos.length > 1) {

					if (this.current === this.photos.length - 1) reel.push({
						index: 0,
						image: this.photos[0].image
					})
					
					if (this.current < this.photos.length - 1) reel.push({
						index: this.current + 1,
						image: this.photos[this.current + 1].image
					})

				}
				
				if (this.photos.length > 3) {

					if (this.current == this.photos.length - 2) reel.push({
						index: 0,
						image: this.photos[0].image
					})

				}

				if (this.photos.length > 1) {

					if (this.current == this.photos.length - 1) reel.push({
						index: 1,
						image: this.photos[1].image
					})

				}
				
				if (this.photos.length > 3) {

					if (this.current < this.photos.length - 2) reel.push({
						index: this.current + 2,
						image: this.photos[this.current + 2].image
					})

				}

			}

            return reel

        }

    },

    created: function() {

        this.$pubsub.$on('photos.open', this.onOpen.bind(this))

    },

    beforeDestroy: function() {

        this.$pubsub.$off('photos.open', this.onOpen.bind(this))

    },

    methods: {

        onLeftClick: function() {

            this.current = (this.current > 0) ? this.current - 1 : this.photos.length - 1

        },

        onRightClick: function() {

            this.current = (this.current < this.photos.length - 1) ? this.current + 1 : 0

        },

        onPhotoClick: function(index) {
          
            this.current = index

        },

        onCloseClick: function() {

            this.is.active = false

        },

        onImageLoaded: function() {

            this.is.loaded = true

        },

        onOpen: function(e) {

            this.photos = e.photos 
            this.current = e.index

            this.is.loaded = false
            this.is.active = true

        }

    }
    
}

</script>

<style scoped>

.photos {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.9);
    z-index: 100000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.photos-share {
	position: absolute;
	top: 10px;
	right: 60px;
	z-index: 2;
}

.photos-close {
    background-color: var(--color-blue-light);
    color: #fff;
    position: absolute;
    right: 10px;
    top: 10px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
	z-index: 2;
    font-size: 24px;
    transition: all 100ms linear;
}

.is-desktop .photos-close:hover {
    background-color: var(--color-blue-dark);
}

.photos-current {
    width: 640px;
    height: 640px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
	z-index: 1;
}

.is-mobile .photos-current {
	width: 100%;
	height: 100vh;
}

.photos-current-image {
    max-width: 580px;
    max-height: 580px;
    opacity: 0;
}

.is-mobile .photos-current-image {
	max-width: 300px;
	max-height: 300px;
}

.photos-current-image.is-loaded {
    opacity: 1;
    transition: all 100ms linear;
}

.photos-current-text {
    position: absolute;
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    text-align: center;
    bottom: 0px;
	padding: 0px 10px;
}

.photos-reel {
    width: 640px;
    height: 64px;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.is-mobile .photos-reel {
	margin-bottom: 20px;
}

.photos-reel-item {
    width: 64px;
    height: 64px;
    cursor: pointer;
    border-radius: 4px;
    background-size: cover;
    background-position: 50% 50%;
    margin: 8px 8px;
    transition: opacity 100ms linear;
    opacity: 0.5;
}

.photos-reel-item.is-active,
.is-desktop .photos-reel-item:hover {
    opacity: 1;
}

.photos-reel-item.is-active {
    transform: scale(1.25);
}

.photos-next {
    height: 40px;
    position: absolute;
    top: 50%;
    margin-top: -20px;
    width: 40px;
    line-height: 40px;
    color: #fff;
    font-size: 24px;
    text-align: center;
    cursor: pointer;
    background-color: var(--color-blue-light);
    transition: all 100ms linear;
	z-index: 2;
}

.is-desktop .photos-next:hover {
    background-color: var(--color-blue-dark);
    width: 48px;
}

.photos-next.is-left {
    left: 0px;
    border-radius: 0px 4px 4px 0px;
}

.photos-next.is-right {
    right: 0px;
    border-radius: 4px 0px 0px 4px;
}

</style>